import { Trash2 } from 'lucide-react'
import { useState } from 'react'

import { Dialog, DialogContent, DialogTrigger } from '@/_components/ui'

import { DeleteUserDialog } from './delete-user-dialog'

type DeleteUserButtonProps = {
  id: string
  name: string
  companyId: string
}

export const DeleteUserButton = ({ id, name, companyId }: DeleteUserButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Trash2 size={18} className="cursor-pointer text-aux-red-danger-6" />
      </DialogTrigger>
      <DialogContent className="min-w-[336px] max-w-[389px] p-5">
        <DeleteUserDialog
          id={id}
          name={name}
          companyId={companyId}
          setIsDialogOpen={setIsDialogOpen}
        />
      </DialogContent>
    </Dialog>
  )
}
